import React from 'react';
import { Printer } from 'lucide-react';

import { Button } from 'shadcn/components/ui/Button';
import { DialogTitle } from 'shadcn/components/ui/Dialog';

import { PrintAllocatedLabelsSummaryCard } from './PrintAllocatedLabelsSummaryCard';
import { getLineItemDisplayFields } from './printAllocatedLabelsUtils';

function handlePrintAllLabels() {
    // TODO: print all labels
}

/**
 * @param {Object} props
 * @param {string} props.poType
 * @param {object} props.rowData
 * @param {{ totalCases: number, numPallets: number }} props.receivedSummary
 */
function PrintAllocatedLabelsModal({ poType, receivedSummary, rowData }) {
    const { itemName, sku, unitsPerCase } = getLineItemDisplayFields(rowData, poType);

    return (
        <>
            <div className="flex items-center justify-between gap-4 border-b py-4 pl-6 pr-12">
                <DialogTitle className="p-0 text-base font-semibold">Print Labels</DialogTitle>
                <Button
                    className="bg-[#4C884B] text-white hover:bg-[#4C884B]/90"
                    type="button"
                    onClick={handlePrintAllLabels}
                >
                    <Printer aria-hidden className="size-4" />
                    Print All Labels
                </Button>
            </div>
            <div className="p-6">
                <PrintAllocatedLabelsSummaryCard
                    itemName={itemName}
                    numPallets={receivedSummary.numPallets}
                    sku={sku}
                    totalCases={receivedSummary.totalCases}
                    unitsPerCase={unitsPerCase}
                />
                <p className="mt-4 text-sm text-muted-foreground">Under Construction</p>
            </div>
        </>
    );
}

export { PrintAllocatedLabelsModal, handlePrintAllLabels };
